"use strict";

(function () {

    $.widget('khis.hierarchySearch', {
        _name: 'hierarchySearch',
        options: {
            width: 'auto',
            border: '1px solid rgb(169, 217, 224)',
            listHeight: '250px',
            title: 'Title',
            clear: 'Clear',
            url: null,
            noResults: '',
            params: {}
        },
        searchTimer: null,
        parentNode: {},
        breadCrums:[],
        resultList: [],
        _create: function () {
            this.element.addClass('hierarchy_search');
            this.element.attr('style', 'width: '+this.options.width+'; border: '+this.options.border+';');

            this.element.append($('<div role="search_ct" style="padding: 8px;"></div>'));
            this.element.append($('<div role="breadcrums_ct" style="display: none;"></div>'));
            this.element.append($('<div role="results_ct" style="height: '+this.options.listHeight+'; overflow-x: hidden; overflow-y: auto; background: transparent url(/assets/progress_bar.gif) no-repeat top center;"></div>'));

            this.searchCt = this.element.find('[role=search_ct]');
            this.breadcrumsCt = this.element.find('[role=breadcrums_ct]');
            this.resultsCt = this.element.find('[role=results_ct]');

            // Search
            var html = '<table style="width: 100%;">';
            html += '<tr><td><label class="float_left" style="color: rgb(0, 160, 175); text-transform: uppercase;">'+this.options.title+'</label><label role="clear" class="float_right" style="color: #595959; cursor: pointer;">'+this.options.clear+'</label></td></tr>';
            html += '<tr><td style="padding-right: 10px;"><input role="search" data-last="" type="text" style="width: 100%;" class="float_left"><span class="float_right ui-icon ui-icon-search"  style="margin-top: -23px;"></span></td></tr>';
            html += '</table>';
            this.searchCt.append($(html));

            // Breadcrums
            html = '<table style="width: 100%;">';
            html += '<tr><td style="cursor: pointer; vertical-align: middle; text-align: center; width: 24px;"><span class="ui-icon ui-icon-carat-1-w"></span></td><td><ul role="breadcrums" style="display: inline; list-style: none; line-height: 20px; font-style: italic; font-weight: bold; font-size: 12px;"></ul></td><td style="cursor: pointer; vertical-align: middle; text-align: center; width: 24px;"><span class="ui-icon ui-icon-close"></span></td></tr>';
            html += '</table>';
            this.breadcrumsCt.append($(html));

            // Results
            html = '<div style="min-height: 250px;"><table style="width: 100%; " class="hierarchy_search_results"></table></div><div role="no_results" style="display: none; font-style: italic; padding: 8px; background-color: #dff0f2; min-height: 41px;">'+this.options.noResults+'</div>';
            this.resultsCt.append($(html));
        },
        _init: function () {
            this.parentNode = {};
            this.breadCrums = [];
            this.resultList = [];

            this._on({
                'click [role=breadcrums_ct] span.ui-icon-carat-1-w': function (evt) {
                    this.goUpper();
                }
            });

            this._on({
                'click [role=clear]': function (evt) {
                    this.reset();
                }
            });

            this._on({
                'click [role=breadcrums_ct] span.ui-icon-close': function (evt) {
                    this.reset();
                }
            });

            this._on({
                'keyup [role=search]': function (evt) {
                    var elem = $(evt.target);
                    if(elem.val().trim() != elem.data('last')){

                        if(elem.val().trim().length > 0){
                            setTimeout('$("#'+this.element.attr('id')+'").' + this._name +'("search");', 250);
                        } else {
                            this.reset();
                        }
                    }

                    elem.data('last', elem.val().trim());
                }
            });

            this._on({
                'click table.hierarchy_search_results td.go_deep': function (evt) {
                    this.goDeeper($(evt.target).closest('tr'));
                }
            });

            this._on({
                'click [role=breadcrums] li.txt_link': function (evt) {
                    this.goToIndex($(evt.target).closest('li').data('index'));
                }
            });

            this.search();
        },
        _destroy: function () {
            this.element.empty();
        },
        search: function(){
            this.drawBreadCrums();

            this.resultsCt.find('table.hierarchy_search_results').parent().hide();
            this.resultsCt.find('[role=no_results]').hide();

            var params = {
                id:this.element.attr('id'),
                parent_id: this.parentNode.id,
                slot_id: this.parentNode.slotId,
                search: $(this.searchCt.find('[role=search]')).val()
            };

            $.extend(params, this.options.params);
            debug.log('search: ', params);
            $.getJSON(this.options.url, params)
                .done(function (data, status, xhr) {
                    Hades.checkIfUserIsAuthorized(data, status, xhr);

                    $('#'+data.id).hierarchySearch('drawList', data.list);
                })
                .fail(function (xhr, status, error) {
                    bootbox.alert(error);
                });
        },
        reset: function() {
            this.breadcrumsCt.slideUp();

            this.clearBreadCrums();

            this.parentNode = {};

            this.search();
        },
        goDeeper: function(parent){
            // Clear search
            $(this.searchCt.find('[role=search]')).val(null);

            this.parentNode = {
                id: $(parent).data('id'),
                slotId: $(parent).data('slot'),
                description: $(parent).find('span.description').html()
            }

            this.breadCrums.push(this.parentNode);

            this.breadcrumsCt.slideDown();

            this.search();
        },
        drawBreadCrums: function(){
            var ct = this.breadcrumsCt.find('[role=breadcrums]');
            $(ct).empty();

            $.each(this.breadCrums, function(index, elem){
                if(index > 0){
                    $('<li class="float_left"><span>&nbsp;&#92;&nbsp;</span></li>').appendTo(ct);
                }

                $('<li data-index="'+index+'" class="float_left txt_link" style="padding: 0 4px;"><span>'+elem.description+'</span></li>').appendTo(ct);
            });
        },
        clearBreadCrums: function(){
            this.breadCrums = [];

            this.breadcrumsCt.find('[role=breadcrums]').empty();
        },
        goToIndex: function(index) {
            this.searchCt.find('[role=search]').val(null);
            this.parentNode = this.breadCrums[index];

            var min = index + 1, max = this.breadCrums.length;

            for(var i = min; i < max; i++){
                this.breadCrums.pop();
            }

            this.search();
        },
        goUpper: function(){
            if(this.breadCrums.length > 1){
                this.parentNode = this.breadCrums.pop();
            } else {
                this.parentNode = {};
                this.breadcrumsCt.find('span.ui-icon-close').click();
            }

            this.search();
        },
        drawList: function(list){
            var
                that = this,
                ct = this.resultsCt.find('table.hierarchy_search_results'),
                row,
                _id,
                _type;

            $(ct).empty();

            this.resultList = list;

            if(list && list.length > 0){
                $.each(list, function(index, elem){
                    _id = elem.physical_space_id;
                    _type = 'physical_space';

                    if(elem.slot_id && elem.slot_id.length >0 ){
                        _id = elem.slot_id;
                        _type = 'slot';
                    }
                    row = that.drawRow(index, elem, _type, _id);

                    $(ct).append(row);
                });



                this.resultsCt.find('[role=no_results]').hide();
                this.resultsCt.find('table.hierarchy_search_results').parent().show();
            } else {
                this.resultsCt.find('table.hierarchy_search_results').parent().hide();
                this.resultsCt.find('[role=no_results]').show();
            }
        },

        drawRow: function (index, elem, type, id){
            var row = $('<tr data-index="'+index+'" data-id="'+elem.physical_space_id+'" data-slot="'+elem.slot_id+'"></tr>');

            var c1 = $('<td style="vertical-align: middle; width: 16px;"><input type="radio" name="hierarchy_search_physical_space" data-type="'+ type+'" value="'+id+'"></td>'), c2, c3, c4;

            if(elem.flg_has_children === true && !(elem.slot_id)){
                c2 = $('<td class="go_deep"><span style="font-weight: bold;" class="description">'+elem.description+'</span><br /><span style="font-style: italic; font-size: 11px;">'+elem.breadcrumbs+'</span></td>');
                c3 = $('<td class="go_deep" style="width: 16px;"><span class="ui-icon ui-icon-carat-1-e"></span></td>');
            } else {
                c2 = $('<td><span style="font-weight: bold;" class="description">'+elem.description+'</span><br /><span style="font-style: italic;">'+elem.breadcrumbs+'</span></td>');
                c3 = $('<td style="width: 24px; text-align: center; vertical-align: middle; cursor: pointer;"></td>');
            }

            //debug.log('draw row', elem);
            //c4 = $('<td class="go_deep" style="width: 16px;"><span class="'+ elem.wf_status_icon +'"></span></td>');

            c1.appendTo(row);
            c2.appendTo(row);
            c3.appendTo(row);
            //c4.appendTo(row);

            return row;
        },

        getBreadCrums: function(){
            return this.breadCrums;
        },
        getResultList: function(){
            return this.resultList;
        },
        getSelectedOption: function(){
            var option = this.resultsCt.find('input[type=radio][name=hierarchy_search_physical_space]:checked');
            var index = $(option).closest('tr').data('index');

            if(index !== undefined){
                return this.resultList[index];
            }

            return null;
        },
        getSelectedOptionAvailability: function () {
            var option = this.resultsCt.find('input[type=radio][name=hierarchy_search_physical_space]:checked');
            var index = $(option).closest('tr').data('index');
            var wf_status_id = null;
            var message = null;

            if(index !== undefined){
                var physical_space = this.resultList[index];

                if(physical_space.slot_id != null) {
                    wf_status_id = physical_space.wf_status_slot_id;
                    message = physical_space.wf_status_slot_description;
                } else {
                    wf_status_id = physical_space.wf_status_physical_space_id;
                    message = physical_space.wf_status_physical_space_description;
                }

                if (wf_status_id == 37 || wf_status_id == 38 || wf_status_id == 39 || wf_status_id == 41 || wf_status_id == 44 || wf_status_id == 45 ||wf_status_id == 46 || wf_status_id == 47) {
                    return {
                        status: true,
                        message: message
                    }
                } else {
                    return {
                        status: false,
                        message: null
                    }
                }
            }
        }

    });

    $.widget('khis.hierarchySearchInpatient', $.khis.hierarchySearch, {
        _name: 'hierarchySearchInpatient',
        drawList: function(list){
            var
                that = this,
                ct = this.resultsCt.find('table.hierarchy_search_results'),
                row,
                _id,
                _type;

            $(ct).empty();

            this.resultList = list;

            if(list && list.length > 0){
                $.each(list, function(index, elem){
                    _id = elem.physical_space_id;
                    _type = 'physical_space';

                    if(elem.slot_id && elem.slot_id.length >0 ){
                        _id = elem.slot_id;
                        _type = 'slot';
                    }
                    row = that.drawRow(index, elem, _type, _id);

                    $(ct).append(row);

                    that.getRowStatus(index, elem.physical_space_id, elem.slot_id, that.options.params.start_date);
                });



                this.resultsCt.find('[role=no_results]').hide();
                this.resultsCt.find('table.hierarchy_search_results').parent().show();
            } else {
                this.resultsCt.find('table.hierarchy_search_results').parent().hide();
                this.resultsCt.find('[role=no_results]').show();
            }
        },

        drawRow: function (index, elem, type, id){

            var row = $('<tr data-index="'+index+'" data-id="'+elem.physical_space_id+'" data-slot="'+elem.slot_id+'"></tr>');

            var c1 = $('<td style="vertical-align: middle; width: 16px;"><input type="radio" name="hierarchy_search_physical_space" data-type="'+type+'" value="'+id+'"></td>'), c2, c3;

            if(elem.flg_has_children === true && !(elem.slot_id)){
                c2 = $('<td class="go_deep"><span style="font-weight: bold;" class="description">'+elem.description+'</span><br /><span style="font-style: italic; font-size: 11px;">'+elem.breadcrumbs+'</span></td>');
                c3 = $('<td class="go_deep" style="width: 16px;"><span class="ui-icon ui-icon-carat-1-e"></span></td>');
            } else {
                c2 = $('<td><span style="font-weight: bold;" class="description">'+elem.description+'</span><br /><span style="font-style: italic;">'+elem.breadcrumbs+'</span></td>');
                c3 = $('<td style="width: 24px; text-align: center; vertical-align: middle; cursor: pointer;"></td>');
            }

            c1.appendTo(row);
            c2.appendTo(row);
            //$('<td style="horizontal-align: right; width: 35px;"> <span data-id="icon-status" style="width: 16px;" class="ui-icon ui-icon-refresh"></span></td>').appendTo(row);
            $('<td style="horizontal-align: right; width: 35px;"> <span data-id="icon-status" class="ui-icon ui-icon-refresh"></span></td>').appendTo(row);
            c3.appendTo(row);


            return row;
        },

        getRowStatus: function (row, physical_space_id, slot_id, start_date){
            var that = this;

            $('tr[data-index=' + row + ']').find('span[data-id=icon-status]').addClass('ui-icon-refresh');

            var params = {
                physical_space_id: physical_space_id,
                slot_id: slot_id,
                start_date: start_date
            };

            $.post('/physical_space/get_slot_status', params)
                    .done(function (data, status, xhr) {
                        Hades.checkIfUserIsAuthorized(data, status, xhr);
                        that.changeSlotStatus(row, data);
                    })
                    .fail(function (xhr, status, error) {
                        Hades.showError(error, xhr.responseText, xhr, status, error);
                    });
        },

        changeSlotStatus: function (row, data) {
            //debug.log('changeSlotStatus:', data);
            if (data.wf_status_icon != null) { // icon indiponible
                $('tr[data-index=' + row + ']').find('span[data-id=icon-status]').removeClass('ui-icon-refresh');
                $('tr[data-index=' + row + ']').find('span[data-id=icon-status]').addClass(data.wf_status_icon);
                $('tr[data-index=' + row + ']').find('span[data-id=icon-status]').removeClass('wf_icon');
                $('tr[data-index=' + row + ']').find('span[data-id=icon-status]').attr('title', data.title);
            } else {
                $('tr[data-index=' + row + ']').find('span[data-id=icon-status]').removeClass('ui-icon-refresh');
                $('tr[data-index=' + row + ']').find('span[data-id=icon-status]').addClass(data.icon);
                $('tr[data-index=' + row + ']').find('span[data-id=icon-status]').attr('title', data.title);
            }

        },

        search: function(){
            this.drawBreadCrums();

            this.resultsCt.find('table.hierarchy_search_results').parent().hide();
            this.resultsCt.find('[role=no_results]').hide();

            var params = {
                id:this.element.attr('id'),
                parent_id: this.parentNode.id,
                slot_id: this.parentNode.slotId,
                search: $(this.searchCt.find('[role=search]')).val()
            };

            $.extend(params, this.options.params);

            debug.log('search:', params, this.options.params);
            $.getJSON(this.options.url, params)
                .done(function (data, status, xhr) {
                    Hades.checkIfUserIsAuthorized(data, status, xhr);
                    $('#'+data.id).hierarchySearchInpatient('drawList', data.list);


                })
                .fail(function (xhr, status, error) {
                    bootbox.alert(error);
                });
        },

        updateSlotStatus: function () {
            var that = this;

            $.each(that.resultList, function(index, elem){

                that.getRowStatus(index, elem.physical_space_id, elem.slot_id, that.options.params.start_date);
            });
        }
    });

})();
